import { create } from 'zustand';
import { User } from '../Types/User';

interface AdminControlState {
    user: User;
    //Actions
    setUser: (name: string, value: any) => void;
    replaceUser: (user: Partial<User>) => void;
    resetToDefaults: () => void;
}

// Default state values
const defaultState = {
    user: {
        id: 0,
        firstName: "",
        lastName: "",
        email: "",
        accountLevel: "User",
        active: true,
        emailVerified: false,
        customers: [],
        resetPassword: false,
        mode: 'dark',
    } as User,
}

const useAdminControlsStore = create<AdminControlState>()((set: Function) => ({
    ...defaultState,

    // Actions
    setUser: function (name: string, value: any) {
        set((prevState: any) => ({
            ...prevState,
            user: {
                ...prevState.user,
                [name]: value,
            }
        }));
    },
    replaceUser: (user: Partial<User>) => set((prevState: any) => ({
        ...prevState,
        user: {
            ...prevState.user,
            ...user,
        }
    })),

    resetToDefaults: () => set(defaultState),
}),
);

export default useAdminControlsStore